export default __webpack_public_path__ + "static/media/lactose.5aae4e43.jpeg";